// Copy for the About Us page. The Statement of Beliefs is the church's text
// verbatim -- don't reword, retitle, split or merge it; the layout adapts to it.

export type ChipIcon = "schedule" | "online";

export const aboutContent = {
  header: {
    eyebrow: "Church of God Cincinnati",
    title: "About Us",
  },

  newHere: {
    eyebrow: "Welcome",
    heading: "New Here? Join Us This Saturday",
    body:
      "The Church of God Cincinnati was founded by people committed to the biblical worship of God, and our focus is on God as revealed through His written word. Whether you're exploring faith or looking for a congregation to call home, we'd be glad to have you worship with us — in person or online.",
    chips: [
      { icon: "schedule", label: "Saturdays at 2:00 PM" },
      { icon: "online", label: "In person & online" },
    ] as { icon: ChipIcon; label: string }[],
    cta: { label: "Plan Your Visit", to: "/visitors" },
  },

  quote: {
    text: "There is no God in heaven or on earth like the God who is revealed through scripture.",
    attribution: "Statement of Beliefs · Church of God Cincinnati",
  },

  beliefs: {
    eyebrow: "Foundations",
    title: "Statement of Beliefs",
    intro: [
      "The Church of God Cincinnati was founded by people who have a commitment to the biblical worship of God. Our focus is on God as revealed through the written word. There is no God in heaven or on earth like the God who is revealed through scripture. Nor is there any building or political structure of men that can contain God. Yet He is with those people who will covenant with Him to serve Him as God.",
      "God declared through the Prophet Isaiah, that “My ways are higher than your ways and my thoughts than your thoughts.” (Isaiah 55:9) Therefore, we recognize that a statement of beliefs is inadequate to fully express the mind of God. With that in mind, the following is a list of items central to our system of beliefs.",
    ],
    // Each entry is one numbered "We believe" paragraph plus any paragraphs that continue it.
    entries: [
      [
        "We believe in God the Father Almighty, eternal and uncreated, without beginning or end. He is Spirit, and those who worship Him must worship Him in spirit and truth. Before all things He existed, and through Him all things came into being. He is the Creator and sustainer of the universe, the source and author of life, and the foundation of all truth and order. Humanity's purpose is to know, worship, and glorify Him, living in harmony with His will and the design of His creation.",
      ],
      [
        "We believe in Jesus Christ, God the Son, who has eternally existed and through whom the Father created all things. He is the only begotten of the Father, conceived by the Holy Spirit, and born of a woman. Through His sinless life, sacrificial death, and atoning sacrifice, He provides the only means of salvation for mankind.",
      ],
      [
        "We believe that He was in the heart of the earth for three days and three nights and that, after His resurrection from the dead, He ascended to the Father as the firstfruits of many brethren. He willingly gave His life for humanity and now serves as our Advocate, our High Priest, and our Elder Brother.",
        "He is the Word made flesh, the Lamb of God who takes away the sins of the world, the promised Messiah, and the coming King. Through His promised return, He remains the only true hope for the world and the One through whom God will establish His righteous Kingdom.",
      ],
      [
        "We believe in the Holy Spirit, which proceeds from the Father and the Son and is the presence and active power of God in the world. Through the Holy Spirit, God works in the hearts and minds of believers, granting understanding, conviction, comfort, guidance, and spiritual strength. The Holy Spirit dwells within Christians as God's seal and as the earnest or guarantee of the eternal life promised to all who faithfully belong to Him.",
      ],
      [
        "We believe that man is made in the image of God, to have dominion over the earth. No other part of God’s creation is equal to man.",
      ],
      [
        "We believe that the Bible is God’s inspired word, which reveals the history of God dealing with man, to express through examples the love God has for man. It is the highest authority for what Christians believe and how they should live. Through studying Scripture, people can learn God's plan of salvation, understand His will, and grow in a holy and meaningful life.",
      ],
      [
        "We believe the Sabbath is an identifying sign of who the Creator is and thus it identifies who we worship. The Sabbath is a memorial of God’s creation of the world. Observing the Sabbath is an outward sign that we recognize God’s authority and reflects our loyalty to Him.",
      ],
      [
        "We believe that the Holy Days given in Leviticus 23 reveal God's plan for humanity. Passover foretold Jesus' sacrifice, Pentecost foretold the coming of the Holy Spirit, and the remaining Holy Days point to future events that God will bring about before and during His kingdom on earth.",
      ],
      [
        "We believe in the resurrection of the dead which will occur at the return of Christ when believers will be raised and transformed.",
      ],
      [
        "We believe in multiple resurrections as described in Revelation 20.",
      ],
    ],
    summary: {
      heading: "To summarize: We believe:",
      items: [
        "God the Father is the author of life.",
        "The authority and inspiration of the Bible.",
        "Salvation by grace through faith in Jesus Christ.",
        "Humanity's fallen nature and need for redemption.",
        "Sabbath observance as a sign of worshiping God as Creator.",
        "The biblical Holy Days as revealing God's plan of salvation and future events.",
        "The future return of Christ and the resurrection of the dead.",
      ],
    },
  },

  banner: {
    eyebrow: "Isaiah 55:9",
    text: "“My ways are higher than your ways and my thoughts than your thoughts.”",
  },

  questions: {
    heading: "Have Questions?",
    body: "We'd love to hear from you! Fill out the form below and we'll get back to you as soon as possible.",
    phone: "(513) 755-0040",
  },
};
